import { post } from './request'

export function jobTypeAdd(data) {
  return post('/api/JobType/Add', data)
}

export function jobTypeUpdate(data) {
  return post('/api/JobType/Update', data)
}

export function jobTypeList(data) {
  return post('/api/JobType/List', data)
}

export function jobTypeDetail(data) {
  return post('/api/JobType/Detail', data)
}

export function jobTypeDelete(data) {
  return post('/api/JobType/Delete', data)
}
